export default async function downloadImageByUrl(url: string): Promise<File | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Image fetching error');

    const contentType = response.headers.get('content-type');
    if (!contentType) throw new Error('Content type not found in response headers');

    let fileName = `${new Date().getTime()}`;
    let fileType = 'jpg';

    const parsedUrl = new URL(url);
    parsedUrl.search = '';
    const clearUrl = parsedUrl.toString();

    const urlParts = clearUrl.split('/');
    const lastPart = urlParts[urlParts.length - 1];
    const nameAndType = lastPart.split('.');

    if (nameAndType.length >= 2) {
      fileName = nameAndType[0];
      fileType = nameAndType[1];
    }

    const blob = await response.blob();
    return new File([blob], `${fileName}.${fileType}`, { type: contentType });
  } catch (error) {
    throw new Error('Failed to insert this file');
  }
}